import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Style from './playPart.module.scss'
import Radio from './component/Radio'
import Image from './component/Image'
import AudioNew from './component/AudioNew'
import Video from './component/Video'
import CryptoJS from 'crypto-js';
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import Wrong from '../../../../assets/theme6/wrong.png'
import Right from '../../../../assets/theme6/right.png'
import axios from '../../../../config/authAxios'
// import { sumitAnswerChallenge } from '../../../../redux/screen/sumitAnswerChallenge'
import MissionComplete from '../challenges/MissionComplete'
import LifiLine from './component/LifiLine'
import authAxios from '../../../../config/authAxios'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import ConfirmBox from './component/ConfirmBox'
import ExitChallengePopup from './component/ExitChallengePopup'
import { useSound } from '../../../../helper/useSound'
import Sound1 from "../../../../assets/theme6/correctSound.mp3"
import Sound2 from "../../../../assets/theme6/wrongSound.mp3"
import Sound3 from "../../../../assets/theme6/quizSound.mp3"
import Sound4 from "../../../../assets/theme6/buzz.mp3"
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import TimeOut from './TimeoutPopup'


const PlayPart = ({ time_criteria = 50, qnaData, chId = null }) => {
    const correctSound = useSound(Sound1, { volume: 0.5 });
    const wrongSound = useSound(Sound2, { volume: 0.5 });
    const timerAudioRef = useRef(null);
    const buzzAudioRef = useRef(null);
    const [timerSoundPlaying, setTimerSoundPlaying] = useState(false);
    const [isSound, setIsSound] = useState(false)

    const location = useLocation()
    let { challengeID: paramChallengeID } = useParams();

    const challengeID = chId || paramChallengeID;

    const [data, setData] = useState([])
    const [options, setOptions] = useState("")
    const [scrollBottom, setScrollBottom] = useState(false)
    const [submitAnswer, setSubmitAnswer] = useState([])
    const [second, setSecond] = useState(false);
    const [flag, setFlag] = useState(true)
    const [submitDisable, setSubmitDisable] = useState(false)
    const [correctAnswer, setCorrectAnswer] = useState(0)
    const [missionId, setMissionId] = useState(null)
    const [result, setResult] = useState(1)  /* 1=neutral 2=right 3=wrong */
    const [count, setCount] = useState(0)
    const [num, setNum] = useState(1)
    const [isBack, setIsBack] = useState(false);
    const [startTime, setStartTime] = useState(null);
    const [timeTaken, setTimeTaken] = useState(0);
    const navigation = useNavigate()
    const [timerCompleted, setTimerCompleted] = useState(false);
    // const [remainTime, setRemainTime] = useState(time_criteria * 60)
    const [showPopup, setShowPopup] = useState(false);
    const [llConfirm, setLLConfirm] = useState(false);
    const [llConfirmId, setLLConfirmId] = useState(null);
    const [missionCompleted, setMissionCompleted] = useState(false);
    const [lifeLineUsed, setLifeLineUsed] = useState([]);
    const [nextMission, setNextMission] = useState({
        challengeHistoryId: null,
        attemptMissionId: "",
        missionQuestion: {},
        isPassed: false
    });
    const [lastLifeline, setLastLifeline] = useState(null)
    const [flipQuestion, setflipQuestion] = useState({});
    const [fiftyFiftyUsed, setFiftyFiftyUsed] = useState(false);
    const [audiencePoll, setAudiencePoll] = useState(false);

    const [isTimerPaused, setIsTimerPaused] = useState(false);
    const [timerKey, setTimerKey] = useState(0);
    const [remainingTime, setRemainingTime] = useState(time_criteria * 60);
    // Time Freeze states
    const [timeFreezeActive, setTimeFreezeActive] = useState(false);
    const [timeFreezeRemaining, setTimeFreezeRemaining] = useState(20);

    const [isFlipping, setIsFlipping] = useState(false);

    const FetchLifeLine = async () => {
        try {
            const response = await authAxios.get(`/users/api/challenge-history/${qnaData?.challengeHistoryId}`);
            setLifeLineUsed(response?.data?.data?.lifelines_used);
        } catch (error) {
            console.error(error);
        }
    }

    const handleLieflineConfirm = (e) => {
        if (timeFreezeActive) {
            return
        }
        setLLConfirm(true)
        setLLConfirmId(e)
    }
    const handleLLClick = () => {
        setLLConfirm(false)
        handleLieflineUse(llConfirmId)
        setLLConfirmId(null)
    }
    const handleLieflineUse = async (e) => {
        try {
            const response = await authAxios.put(`/users/api/update-lifeline/${qnaData?.challengeHistoryId}`, { lifeline_id: e });
            console.log("response?.data?.data?.flip_question", response?.data?.data)
            console.log("response?.data?.data?.flip_question", response?.data?.flip_question?.flip_question)
            setLastLifeline(e)
            if (response?.data?.flip_question) {
                console.log("response?.flip_question?.flip_question", response?.data?.flip_question.flip_question)
                setIsFlipping(true);

                // After flip animation completes (halfway through), update the question
                setTimeout(() => {

                    setflipQuestion(response?.data?.flip_question.flip_question)
                    setFiftyFiftyUsed(false)
                    setAudiencePoll(false)
                }, 400); // Change question at midpoint of 0.8s animation

                // Reset animation state after animation completes
                setTimeout(() => {
                    setIsFlipping(false);
                }, 800);



            } else if (e?.toString() == "68f0f8dfd2910ad6f1475434") {
                setFiftyFiftyUsed(true)
                setAudiencePoll(false)
            } else if (e?.toString() == "68f0f825d2910ad6f1475417") {
                setAudiencePoll(true)
            } else if (e?.toString() == "68f0f901d2910ad6f147543e") {
                setTimeFreezeActive(true);
                setTimeFreezeRemaining(20);
                setIsTimerPaused(true);
            }

        } catch (error) {
            console.error(error);
        }
        finally {
            await FetchLifeLine()
        }
    }
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            alert("hello world")
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        setMissionId(qnaData?.attemptMissionId)
        console.log("qnaData?.missionQuestion?.link_qns=====114>", qnaData?.missionQuestion?.link_qns)
        setData(qnaData?.missionQuestion?.link_qns)
    }, [])

    const next = () => {
        setTimeout(() => {
            if (flipQuestion?._id) {
                setflipQuestion({});
            }
            if (fiftyFiftyUsed) {
                setFiftyFiftyUsed(false)
            }
            if (audiencePoll) {
                setAudiencePoll(false)
            }
            setOptions("")
            setCount(count + 1);

        }, 1000);

    }


    const nextClickHandler = async ({ selectedOption, question }) => {
        try {

            if (!question) return; // safety check

            const payload = {
                option_id: selectedOption, // depends on your data
                question_id: flipQuestion?._id || data[count]?._id,
                missionID: qnaData?.missionQuestion?._id,
                challengeId: challengeID,
                challengeHistoryId: qnaData?.challengeHistoryId,
                lifelineId: lastLifeline
            };

            const nextApi = await axios.post(
                `/users/api/question/update/${qnaData?.attemptMissionId}`,
                payload
            );
            console.log("nextApi", nextApi?.data)
            if (nextApi?.data?.statusCode !== 200) {

                alert(nextApi?.data?.message)

            }
            const encryptedData = nextApi?.data?.nextMission
            let response = {
                ...nextApi?.data
            }
            if (encryptedData?.length > 10) {
                const secretKey = process.env.REACT_APP_MY_SECRET_KEY
                const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, secretKey);

                const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
                const jsonData = JSON.parse(decryptedData);
                response.nextMission = jsonData
            }

            if (response.status) {
                if (timerAudioRef.current) {
                    timerAudioRef.current.pause();
                }
                setCorrectAnswer(correctAnswer + 1)
                setResult(2)
                correctSound.play();

                setTimeout(() => {
                    setResult(1)
                    if (response?.nextMission) {
                        setNextMission({
                            challengeHistoryId: qnaData?.challengeHistoryId,
                            attemptMissionId: qnaData?.attemptMissionId,
                            missionQuestion: response?.nextMission,
                            challangeData: qnaData?.challangeData,
                            isPassed: true
                        })
                        setMissionCompleted(true)

                        const endTime = Date.now();
                        const durationInSeconds = Math.floor((endTime - startTime) / 1000);
                        setTimeTaken(durationInSeconds);

                    } else if (response?.challengeCompleted) {
                        navigation(`/mission-success/${qnaData?.challengeHistoryId}`, {
                            state: { is_mission: qnaData?.challangeData?.is_mission }
                        })
                    } else {
                        if (timerAudioRef.current && !isTimerPaused && remainingTime > 10) {
                            timerAudioRef.current.play().catch(err => {
                                console.log('Timer sound resume failed:', err);
                            });
                        }
                    }
                    window.scrollTo(0, 0)
                }, 1000);
                next();
                setSecond(true);
            } else {
                if (timerAudioRef.current) {
                    timerAudioRef.current.pause();
                    timerAudioRef.current.currentTime = 0; // Reset to start
                }

                setResult(3)
                wrongSound.play()
                setTimeout(() => {
                    setResult(1)
                    setNextMission({
                        challengeHistoryId: null,
                        attemptMissionId: null,
                        missionQuestion: {},
                        isPassed: false
                    })
                    setMissionCompleted(true)
                    const endTime = Date.now();
                    const durationInSeconds = Math.floor((endTime - startTime) / 1000);
                    setTimeTaken(durationInSeconds);

                }, 1000);
            }
            if (timeFreezeActive) {
                setTimeFreezeActive(false);
                setIsTimerPaused(false);
                setTimerKey(prev => prev + 1);
            }

        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        timerAudioRef.current = new Audio(Sound3);
        timerAudioRef.current.loop = true;
        timerAudioRef.current.volume = 0.3; // Adjust volume
        timerAudioRef.current.muted = isSound;

        buzzAudioRef.current = new Audio(Sound4);
        buzzAudioRef.current.volume = 0.6;
        buzzAudioRef.current.muted = isSound;


        return () => {
            if (timerAudioRef.current) {
                timerAudioRef.current.pause();
                timerAudioRef.current = null;
            }
            if (buzzAudioRef.current) {
                buzzAudioRef.current.pause();
                buzzAudioRef.current = null;
            }
        };
    }, []);
    useEffect(() => {
        if (timerAudioRef.current) {
            timerAudioRef.current.muted = isSound;
        }
        if (buzzAudioRef.current) {
            buzzAudioRef.current.muted = isSound;
        }
    }, [isSound]);

    // Start timer sound when component mounts
    useEffect(() => {
        if (timerAudioRef.current && !timerSoundPlaying) {
            timerAudioRef.current.play().catch(err => {
                console.log('Timer sound autoplay blocked:', err);
            });
            setTimerSoundPlaying(true);
        }
    }, []);

    // Stop timer sound when timer is paused (Time Freeze)
    useEffect(() => {
        if (timerAudioRef.current) {
            if (isTimerPaused) {
                timerAudioRef.current.pause();
            } else if (timerSoundPlaying) {
                timerAudioRef.current.play();
            }
        }
    }, [isTimerPaused]);




    useEffect(() => {
        setStartTime(Date.now());
        FetchLifeLine()
    }, []);


    useEffect(() => {
        if (scrollBottom) {
            // debugger
            window.scrollTo(0, 10000)
            setScrollBottom(false)
        }
    }, [scrollBottom])

    useEffect(() => {
        let prevLocation = location.pathname;
        let prevHistoryLength = window.history.length;
        const handlePopState = () => {
            const currentLocation = location.pathname;
            const currentHistoryLength = window.history.length;
            if (currentHistoryLength < prevHistoryLength || currentLocation !== prevLocation) {
                setIsBack(true);
            } else {
                setShowPopup(true)
                setIsBack(false);
            }
            prevLocation = currentLocation;
            prevHistoryLength = currentHistoryLength;
        };
        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [location]);

    const questionType = flipQuestion?.type ?? data[count]?.type;

    return (
        <>

            {missionCompleted ?
                <MissionComplete currentMission={qnaData?.missionQuestion?._id} timeTaken={timeTaken} missionData={nextMission} challengeID={challengeID} missionId={missionId} /> :
                <>
                    {qnaData?.challangeData?.available_lifelines?.length > 0 &&
                        <div className={Style.life_line_box}>
                            <LifiLine challengeHistoryId={qnaData?.challengeHistoryId}
                                available_lifelines={qnaData?.challangeData?.available_lifelines}
                                lifeLineUsed={lifeLineUsed}
                                lifeClick={(e) => handleLieflineConfirm(e)}
                            />


                        </div>}
                    <div className={Style.volumeBtn} onClick={() => setIsSound(!isSound)}>
                        {isSound ? <VolumeOffIcon sx={{ color: "white", width: '18px', height: '18px' }} /> : <VolumeUpIcon sx={{ color: "white", width: '18px', height: '18px' }} />}
                    </div>

                    <div className={Style.circular__bar}>
                        <CountdownCircleTimer
                            key={timerKey}
                            isPlaying={!isTimerPaused}
                            duration={time_criteria * 60}
                            initialRemainingTime={remainingTime}
                            size={60}
                            strokeWidth={5}
                            colors={'#FF1C00'}
                            rotation={'counterclockwise'}

                            onUpdate={(remaining) => {
                                if (!isTimerPaused) {
                                    setRemainingTime(remaining);

                                    // Last 10 seconds me buzz sound play karo
                                    if (remaining <= 5) {
                                        // Stop timer sound
                                        if (timerAudioRef.current) {
                                            timerAudioRef.current.pause();
                                        }
                                        // Play buzz sound
                                        if (buzzAudioRef.current) {
                                            buzzAudioRef.current.play().catch(err => {
                                                console.log('Buzz sound failed:', err);
                                            });
                                        }
                                    }
                                }
                            }}
                            onComplete={() => {
                                // Stop all sounds
                                if (timerAudioRef.current) {
                                    timerAudioRef.current.pause();
                                }
                                if (buzzAudioRef.current) {
                                    buzzAudioRef.current.pause();
                                }
                                setTimerCompleted(true);
                                return { shouldRepeat: false };
                            }}
                        >
                            {({ remainingTime }) => (
                                <div style={{ color: '#FF1C00', fontWeight: "700" }}>
                                    {`${remainingTime}s`}
                                </div>
                            )}
                        </CountdownCircleTimer>

                        {timeFreezeActive && (
                            <div className={Style.timefreeze_overlay}>
                                <div className={Style.timefreeze_content}>
                                    <CountdownCircleTimer
                                        isPlaying
                                        duration={20}
                                        initialRemainingTime={20}
                                        size={63}
                                        strokeWidth={6}
                                        rotation='counterclockwise'
                                        colors={['#436CFF', '#1F50FF', '#7B97FF']}
                                        colorsTime={[20, 10, 0]}
                                        onComplete={() => {
                                            // Time freeze complete - resume main timer
                                            setTimeFreezeActive(false);
                                            setIsTimerPaused(false);
                                            setTimerKey(prev => prev + 1); // Force re-render with saved remaining time
                                            return { shouldRepeat: false };
                                        }}
                                    >
                                        {() => (
                                            <div style={{ width: "26px", height: "26px" }}>
                                                <img src='https://d1qj6ph0z4cul6.cloudfront.net/live/pr_f_lock-img-qz_1761504203089.png' alt='lock' width="100%" height="100%" />                                                            </div>
                                        )}
                                    </CountdownCircleTimer>
                                </div>
                            </div>
                        )}



                    </div>
                    <div className={Style.container} key={data[count]?._id}>
                        <div className={Style.Qus__area}>


                            <div className={Style.count__number}>
                                <p>Q.{count + 1}</p>
                            </div>

                            <div
                                className={`${Style.shadow__area__q__img} ${isFlipping && Style.flip__animation}`}>
                                {/* <div className={Style.volumeBtn} onClick={() => setIsSound(!isSound)}>
                                    {isSound ?  <VolumeOffIcon sx={{ color: "white" }} /> : <VolumeUpIcon sx={{ color: "white" }} /> }
                                </div> */}


                                <div className={Style.main__area__q}>


                                    <div className={Style.question__area}>
                                        <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center", justifyContent: "center", position: "relative", marginTop: '25px' }}>


                                            {<p style={{ textAlign: "center", opacity: result !== 1 ? 0.1 : 1 }}>{flipQuestion?.question || data[count]?.question}</p>}
                                            {result == 2 && <div className={Style.wrong}>
                                                <img src={Right} width={"150px"} alt="right" />
                                            </div>}
                                            {result == 3 && <div className={Style.right}>
                                                <img src={Wrong} width={"150px"} alt="wrong" />
                                            </div>}

                                            {<div className={Style.file__area} style={{ opacity: result !== 1 ? 0.1 : 1 }}>
                                                {questionType === 'image' && <Image image={flipQuestion?.file_url || data[count]?.file_url} />}
                                                {questionType === 'audio' && <AudioNew audio={flipQuestion?.file_url || data[count]?.file_url} />}
                                                {questionType === 'video' && <Video video={flipQuestion?.file_url || data[count]?.file_url} />}
                                            </div>}
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className={Style.Ans__area}>

                            <div className={Style.shadow__area}>
                                <div className={Style.main__area}>
                                    <Radio
                                        getRadioData={flipQuestion?.options || data[count]?.options}
                                        options={options}
                                        setOptions={setOptions}
                                        setScrollBottom={setScrollBottom}
                                        result={result}
                                        setResult={setResult}
                                        nextClickHandler={nextClickHandler}
                                        fiftyFiftyUsed={fiftyFiftyUsed}
                                        audiencePoll={audiencePoll}
                                        latestLifeLine={lastLifeline}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {timerCompleted && <TimeOut showPopup={timerCompleted} redirectpage={"home-challenge"} />}
                    {showPopup && <ExitChallengePopup open={showPopup} setOpen={setShowPopup} message=' You will loose your rewards if you quit midway.' Ismiision={qnaData?.challangeData?.is_mission} />}
                    {llConfirm && <ConfirmBox open={llConfirm} setOpen={setLLConfirm} onCLick={handleLLClick} />}
                </>}
        </>
    )
}





export default PlayPart;